module.exports = __webpack_public_path__ + "img/maps-marker-assign.94fa427b.svg";